/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, react/no-array-index-key */

import React from 'react'
import clsx from 'clsx'

import get from 'lodash/get'
import defaultTo from 'lodash/defaultTo'
import toPairs from 'lodash/toPairs'
import sortBy from 'lodash/sortBy'

import ClickAway from '../../utils/ClickAway'
import Icon from '../../Icon'

import styles from './styles.module.scss'

export interface DropdownLinkProps {
  data: { [key: string]: any }
  value?: any
  textValue?: any
  ordered?: boolean
  className?: string
  onChange: (value: any) => void
}

const DropdownLink: React.FC<DropdownLinkProps> = ({
  data,
  value,
  textValue,
  ordered,
  className,
  onChange,
}) => {
  const [isDropdownVisible, setIsDropdownVisible] =
    React.useState<boolean>(false)

  const currentTextValue = defaultTo(textValue, get(data, value, ''))

  const handleShowDropdown = React.useCallback(
    () => setIsDropdownVisible(true),
    [],
  )
  const handleHideDropdown = React.useCallback(
    () => setIsDropdownVisible(false),
    [],
  )

  const handleChange = React.useCallback(
    (keyValue: any) => () => {
      handleHideDropdown()
      onChange(keyValue)
    },
    [handleHideDropdown, onChange],
  )

  return (
    <div className={clsx(className, styles.container)}>
      <div
        onClick={handleShowDropdown}
        className={clsx(styles.label, isDropdownVisible && styles.active)}
      >
        {currentTextValue}
        <Icon name="caret-down" />
      </div>
      <ClickAway callback={handleHideDropdown}>
        <ul
          className={clsx(
            styles.dropdownContainer,
            isDropdownVisible && styles.visible,
          )}
          onClick={() => {}}
        >
          {React.useMemo(() => {
            return ordered ? (
              <>
                {sortBy(toPairs(data), '[1]').map((pair, i) => {
                  const keyValue = get(pair, '[0]')
                  const text = get(pair, '[1]')
                  return (
                    <li
                      key={`dropdown_link_${keyValue}_${i}`}
                      onClick={() => handleChange(keyValue)}
                      className={clsx(keyValue === value && 'active')}
                    >
                      {text}
                    </li>
                  )
                })}
              </>
            ) : (
              Object.keys(data).map((keyValue, i) => {
                const text = get(data, keyValue)
                return (
                  <li
                    key={`dropdown_link_${keyValue}_${i}`}
                    onClick={() => handleChange(keyValue)}
                    className={clsx(keyValue === value && 'active')}
                  >
                    {text}
                  </li>
                )
              })
            )
          }, [data, handleChange, ordered, value])}
        </ul>
      </ClickAway>
    </div>
  )
}

export default React.memo(DropdownLink)
